(ns practitest.frontend.batch-modal.subs
  (:require [practitest.frontend.components.grid.subs :as grid.subs]
            [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::batch-modal
  (fn [db [_]]
    (:batch-modal db)))

(re-frame/reg-sub
  ::open?
  :<- [::batch-modal]
  (fn [modal [_]]
    (boolean (:open? modal))))

(re-frame/reg-sub
  ::mode
  :<- [::batch-modal]
  (fn [modal [_]]
    (:mode modal)))

(re-frame/reg-sub
  ::entity
  :<- [::batch-modal]
  (fn [modal [_]]
    (:entity modal)))

(re-frame/reg-sub
  ::selection
  :<- [::batch-modal]
  (fn [modal [_]]
    (:selection modal)))

(re-frame/reg-sub
  ::current-view
  :<- [::batch-modal]
  (fn [modal [_]]
    (:current-view modal)))

(re-frame/reg-sub
  ::state-key
  :<- [::batch-modal]
  (fn [modal [_]]
    (:state-key modal)))

(re-frame/reg-sub
  ::filter
  :<- [::batch-modal]
  (fn [modal [_]]
    (:filter modal)))

;; Only set when editing instances nested inside one Test Set - scopes the
;; batch-common-values/batch-edit-apply requests to that set's instances.
(re-frame/reg-sub
  ::set-id
  :<- [::batch-modal]
  (fn [modal [_]]
    (:set-id modal)))

(re-frame/reg-sub
  ::comment
  :<- [::batch-modal]
  (fn [modal [_]]
    (:comment modal)))

(re-frame/reg-sub
  ::disable-notifications?
  :<- [::batch-modal]
  (fn [modal [_]]
    (boolean (:disable-notifications? modal))))

(re-frame/reg-sub
  ::field-values
  :<- [::batch-modal]
  (fn [modal [_]]
    (:field-values modal)))

(re-frame/reg-sub
  ::field-errors
  :<- [::batch-modal]
  (fn [modal [_]]
    (:field-errors modal)))

(re-frame/reg-sub
  ::preserve-tags?
  :<- [::batch-modal]
  (fn [modal [_]]
    (boolean (:preserve-tags? modal))))

(re-frame/reg-sub
  ::common-values
  :<- [::batch-modal]
  (fn [modal [_]]
    (:common-values modal)))

(re-frame/reg-sub
  ::checked-fields-count
  :<- [::field-values]
  (fn [field-values [_]]
    (count (filter :checked? (vals field-values)))))

;; One external entity locks the mapped fields for the whole batch.
(re-frame/reg-sub
  ::integrated-entities?
  (fn [db [_]]
    (let [{:keys [entity state-key selection]} (:batch-modal db)
          rows (get-in db [:entity entity state-key :data])
          selected-rows (if (grid.subs/full-selection? selection)
                          rows
                          (filter #(contains? selection (:id %)) rows))]
      (boolean (some :external_id selected-rows)))))
